var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { formControlLabelClasses, FormControlLabel as BaseFormControlLabel, } from '../form';
import MuiSwitch from '@mui/material/Switch';
import { styled } from '../styled';
import clsx from '../utils/clsx';
import { switchComponentName, switchClasses, getSwitchUtilityClass } from './switch-classes';
import { useMergedClasses } from '../styles/classes';
var SwitchHeight = 24;
var SwitchLineHeight = 18;
var StyledFormControlLabel = styled(BaseFormControlLabel, {
    name: switchComponentName,
    slot: 'FormControlLabel',
})(function (_a) {
    var _b, _c;
    var theme = _a.theme, noWrap = _a.noWrap, labelPlacement = _a.labelPlacement;
    return __assign((_b = { paddingLeft: 0, paddingTop: 0, paddingBottom: 0, marginLeft: 0 }, _b["& .".concat(formControlLabelClasses.container)] = {
        lineHeight: theme.typography.pxToRem(SwitchHeight),
        minWidth: noWrap ? 0 : undefined,
        marginLeft: theme.spacing(2),
        '& > *:first-child': {
            marginLeft: 0,
        },
    }, _b), (labelPlacement === 'start' && (_c = {},
        _c["& .".concat(formControlLabelClasses.container)] = {
            marginLeft: 0,
            marginRight: theme.spacing(2),
        },
        _c)));
});
export var Switch = React.forwardRef(function (props, ref) {
    var children = props.children, noWrap = props.noWrap, labelPlacement = props.labelPlacement, labels = props.labels, checked = props.checked, disabled = props.disabled, readOnly = props.readOnly, defaultChecked = props.defaultChecked, className = props.className, onValueChange = props.onValueChange, onChange = props.onChange, helperText = props.helperText, _a = props.HelperTextProps, HelperTextProps = _a === void 0 ? {} : _a, decoration = props.decoration, propClasses = props.classes, switchProps = __rest(props, ["children", "noWrap", "labelPlacement", "labels", "checked", "disabled", "readOnly", "defaultChecked", "className", "onValueChange", "onChange", "helperText", "HelperTextProps", "decoration", "classes"]);
    var classes = useMergedClasses(switchClasses, getSwitchUtilityClass, propClasses);
    var valueLabel = labels && labels.length === 2 ? labels[checked || defaultChecked ? 0 : 1] : '';
    var label = children || valueLabel;
    var hasLabelOrHelperText = !!helperText || !!label;
    var handleChange = function (event) {
        if (onChange) {
            onChange(event, event.target.checked);
        }
        if (onValueChange) {
            onValueChange(event.target.checked);
        }
    };
    var switchButton = (React.createElement(MuiSwitch, __assign({ checked: checked, disabled: readOnly || disabled, defaultChecked: defaultChecked, className: !hasLabelOrHelperText ? className : classes.switch, onChange: onChange || onValueChange ? handleChange : undefined }, switchProps, { ref: ref })));
    if (hasLabelOrHelperText) {
        return (React.createElement(StyledFormControlLabel, { className: clsx(classes.formControlLabel, className), height: SwitchLineHeight, label: label, labelPlacement: labelPlacement, helperText: helperText, HelperTextProps: HelperTextProps, decoration: decoration, noWrap: noWrap, disabled: readOnly || disabled, control: switchButton, ref: ref }));
    }
    return switchButton;
});
